import { ISection, Language } from '@/lib/interfaces/interfaces'

export type PriceKind = 'price' | 'halfprice' | 'tapaprice'

// Devuelve el nombre personalizado de un slot de precio de una sección.
// Resolución: label en `language` → label en `defaultLanguage` → undefined.
// Los callers aplican su propio fallback (etiqueta i18n del editor, porción
// pública, o tag legacy de delivery) cuando devuelve undefined.
export const getPriceLabel = (
  section: ISection | undefined,
  kind: PriceKind,
  language: Language,
  defaultLanguage?: Language
): string | undefined => {
  if (!section) return undefined

  const keyFor = (lang: Language) => `${kind}Label_${lang}` as keyof ISection
  const read = (lang: Language): string | undefined => {
    const value = section[keyFor(lang)]
    if (typeof value === 'string' && value.trim().length > 0) return value
    return undefined
  }

  return read(language) ?? (defaultLanguage ? read(defaultLanguage) : undefined)
}
